/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { getPayloadObject, getTelemetryAttributes, ITelemetryContent, TelemetryConstant } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface ICheckoutDeliveryOptionsGrpRadioButtonProps {
    className: string;
    isChecked: boolean;
    value?: string;
    ariaSetSize: number;
    ariaPosInSet: number;
    groupName: string;
    ariaLabel?: string;
    telemetryContent?: ITelemetryContent;
    onChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

/**
 * AddPaymentForm SFC.
 * @param root0
 * @param root0.isChecked
 * @param root0.value
 * @param root0.ariaSetSize
 * @param root0.ariaPosInSet
 * @param root0.ariaLabel
 * @param root0.telemetryContent
 * @param root0.onChange
 * @extends {React.FC<ICheckoutDeliveryOptionsGrpRadioButtonProps>}
 */
const CheckoutDeliveryOptionsGrpRadioButton: React.FC<ICheckoutDeliveryOptionsGrpRadioButtonProps> = ({
    className,
    isChecked,
    value,
    ariaSetSize,
    ariaPosInSet,
    ariaLabel,
    groupName,
    telemetryContent,
    onChange
}) => {
    if (!value) {
        return null;
    }

    const payLoad = getPayloadObject('click', telemetryContent!, TelemetryConstant.DeliveryOptions);
    const attributes = getTelemetryAttributes(telemetryContent!, payLoad);
    const deliveryOptionRef: React.RefObject<HTMLInputElement> = React.createRef();

    return (
        <input
            className={className}
            checked={isChecked}
            aria-checked={isChecked}
            type='radio'
            aria-setsize={ariaSetSize}
            aria-posinset={ariaPosInSet}
            aria-label={payLoad.contentAction.etext && ariaLabel ? `${ariaLabel} ${payLoad.contentAction.etext}` : ariaLabel}
            value={value}
            name={groupName}
            {...attributes}
            ref={deliveryOptionRef}
            onChange={onChange}
        />
    );
};

export default CheckoutDeliveryOptionsGrpRadioButton;
